import { render, staticRenderFns } from "./Createreal.vue?vue&type=template&id=0ae94a7e"
import script from "./Createreal.vue?vue&type=script&lang=js"
export * from "./Createreal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports